<template>
  <div class="space-y-2">
    <label :for="questionId + '-yes'" class="block text-sm font-medium text-gray-700">
      {{ questionText }}
      <span v-if="required" class="text-red-500">*</span>
    </label>
    <div class="flex items-center space-x-4">
      <div v-for="option in options" :key="option.value === null ? 'null-value' : option.value.toString()" class="flex items-center">
        <input 
          :id="questionId + '-' + option.label.toLowerCase().replace('/', '')" 
          :name="name" 
          type="radio"
          :value="option.value"
          :checked="modelValue === option.value"
          @change="$emit('update:modelValue', option.value)"
          class="h-4 w-4 text-orchestra-primary border-gray-300 focus:ring-orchestra-primary"
        />
        <label :for="questionId + '-' + option.label.toLowerCase().replace('/', '')" class="ml-2 block text-sm text-gray-700">{{ option.label }}</label>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue'; // props variable removed

defineProps({ // Props are defined here and automatically available
  modelValue: {
    type: [Boolean, String, null],
    default: null
  },
  name: {
    type: String,
    required: true
  },
  questionText: {
    type: String,
    required: true
  },
  questionId: {
    type: String,
    required: true
  },
  required: {
    type: Boolean,
    default: true
  }
});

defineEmits(['update:modelValue']);

const options = [
  { label: 'Yes', value: true },
  { label: 'No', value: false },
  { label: 'N/A', value: 'na' } 
];
</script>